import { render, staticRenderFns } from "./TheLeftSidebar.vue?vue&type=template&id=c00b4b08&scoped=true"
import script from "./TheLeftSidebar.vue?vue&type=script&lang=js"
export * from "./TheLeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./TheLeftSidebar.vue?vue&type=style&index=0&id=c00b4b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00b4b08",
  null
  
)

export default component.exports